import React from 'react'
import { Link } from 'react-router-dom';

const District2Header = () => {
    return (
        <>
            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">

                <Link to="/master/district-list" className="btn btn-primary">
                    <span>Back</span>
                </Link>
            </div>

        </>
    )
}

export default District2Header